"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StreamNetwork = void 0;
var StreamNetwork;
(function (StreamNetwork) {
    StreamNetwork["APTOS"] = "aptos";
    StreamNetwork["EVM"] = "evm";
})(StreamNetwork = exports.StreamNetwork || (exports.StreamNetwork = {}));
//# sourceMappingURL=StreamNetwork.js.map